import {
  Drawer,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Text,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { CreateOfferDrawerContent } from './createOffer/CreateOfferDrawerContent';

interface Props {
  variantId: number;
  isOpen: boolean;
  onClose: () => void;
}

export function CreateOfferModal({ variantId, isOpen, onClose }: Props) {
  const { t } = useTranslation();

  return (
    <Drawer isOpen={isOpen} onClose={onClose} placement="right" size="lg">
      <DrawerOverlay />
      <DrawerContent
        bg="offerDrawer.surface"
        borderLeftRadius={0}
        color="entityDirectory.text"
      >
        <DrawerHeader
          borderBottom="1px solid"
          borderColor="offerDrawer.border"
          px={6}
          py={5}
          pr={16}
        >
          <Text
            fontFamily="barlow"
            fontSize="22px"
            fontWeight="bold"
            lineHeight="28px"
          >
            {t('offer.createDraftOffer')}
          </Text>
          <Text
            color="offerDrawer.mutedText"
            fontSize="13px"
            fontWeight="normal"
            mt={1}
          >
            {t('offer.createDraftOfferDescription')}
          </Text>
        </DrawerHeader>
        <DrawerCloseButton
          border="1px solid"
          borderColor="offerDrawer.borderStrong"
          right={5}
          top={5}
        />
        {isOpen && (
          <CreateOfferDrawerContent variantId={variantId} onClose={onClose} />
        )}
      </DrawerContent>
    </Drawer>
  );
}
